module.exports = __webpack_public_path__ + "img/brainfit_6.685c6fb4.jpg";